import React, { useState, useEffect } from "react";
import Modal from "../../components/Modal";
import VerificationInput from "react-verification-input";
import styles from "./MFA.module.sass";
import { AuthLoginMFA } from "../../auth";
import Cookie from "universal-cookie";
import GlobalSpinner from "../../components/Spinner";
import { useUser } from "../../context";

export function LoginWithMFA({
	isOpen,
	onClose,
	body,
	setVerifyData = () => {},
	setOpen = () => {},
}) {
	const [loading, setLoading] = useState(false);
	const { setLogged, setTokens, setUsername, interval, setbrand } = useUser();

	const handleChange = (value) => {
		if (value.length === 6) {
			AuthLoginMFA(
				{
					...body,
					userCode: value,
				},
				Cookie,
				interval,
				setLogged,
				setTokens,
				setLoading,
				setUsername,
				setVerifyData,
				setbrand
			);
		}
	};

	useEffect(() => {
		return () => {
			setLoading(false);
			setVerifyData({ username: "", confirmationCode: "" });
			setOpen(false);
		};
	}, []);

	return (
		<Modal
			visible={isOpen}
			onClose={onClose}
			children={
				<>
					<h2>MFA verification</h2>
					<p style={{ color: "grey" }}>Please enter the code:</p>
					<VerificationInput
						autoFocus
						validChars="0-9"
						length={6}
						onChange={handleChange}
						classNames={{
							container: styles.container,
							character: `${styles.bit} ${styles.bg_tint_orange}`,
							characterInactive: styles.bit__inactive,
							characterSelected: styles.bit__selected,
						}}
					/>
					{loading && <GlobalSpinner />}
				</>
			}
		/>
	);
}
